module.exports = __webpack_public_path__ + "img/vcontroller-show-cochl.3e6a34c7.png";